export enum RecordVisibilityMode {
  Public = 1,
  Private = 2,
  Restricted = 3,
}
